module.exports = __webpack_public_path__ + "media/images/map-icons/motorcycle_selected-cc2a21458ec20ec9b4c4faa0e919b443.svg";